import {
  BuildOutlined,
  LocalFireDepartmentOutlined,
  NewspaperOutlined,
  NotificationsActiveOutlined,
  ShieldOutlined,
  ThunderstormOutlined,
  WarningAmberOutlined,
} from '@mui/icons-material';
import colors from '../colors.styles';
import config from '../config';
import { initTargeting } from '../tasks/TaskTargeting.utils';

const { ALL_LANGUAGES } = config;

// `name` is the MUI icon name, which is what gets stored with the alert.
export const ALERT_ICONS = [
  { name: 'WarningAmberOutlined', Icon: WarningAmberOutlined },
  { name: 'ShieldOutlined', Icon: ShieldOutlined },
  { name: 'ThunderstormOutlined', Icon: ThunderstormOutlined },
  { name: 'BuildOutlined', Icon: BuildOutlined },
  { name: 'NotificationsActiveOutlined', Icon: NotificationsActiveOutlined },
  { name: 'NewspaperOutlined', Icon: NewspaperOutlined },
  { name: 'LocalFireDepartmentOutlined', Icon: LocalFireDepartmentOutlined },
];

// `accent` colors the headline, icon, and call-to-action button.
export const ALERT_APPEARANCES = [
  {
    value: 'high',
    label: '!!!  High',
    background: colors.base.spark_yellow,
    accent: colors.base.bentonville_blue,
    description: colors.base.bentonville_blue,
  },
  {
    value: 'normal',
    label: '!!  Normal',
    background: colors.base.bentonville_blue,
    accent: colors.base.spark_yellow,
    description: colors.base.light,
  },
  {
    value: 'low',
    label: '!  Low',
    background: '#e9ecee',
    accent: colors.base.bentonville_blue,
    description: colors.base.bentonville_blue,
  },
];

function createEmptyLanguageCopy() {
  return {
    headline: '',
    details: '',
    cta_text: '',
    cta_link: '',
  };
}

export function createEmptyAlert() {
  return {
    languages: ALL_LANGUAGES.reduce(
      (languages, language) => ({
        ...languages,
        [language]: createEmptyLanguageCopy(),
      }),
      {}
    ),
    appearance: 'normal',
    icon: ALERT_ICONS[0].name,
    cta_enabled: false,
    // null start means "Immediately".
    start: null,
    end: null,
    targeting: initTargeting(),
  };
}
